<footer class="app-footer container-fluid w-100">
  <div class="footer-content row w-100 d-flex align-items-center">
    <div class="feedback-tool d-none d-sm-inline-block col-4 text-start">
      &copy; {{ currentYear }} Cannonball Creative

      <!-- <label>
        <input type="checkbox" id="ph-toolbar-toggle" [checked]="feedbackToolEnabled" (change)="onFeedbackToolToggle($event)" />
        Feedback Tool
      </label> -->
    </div>
    <div class="copyright col-12 col-sm-4 text-center text-sm-center"> <span class="confidential">Confidential</span></div>
    <div class="version col-12 col-sm-4 text-center text-sm-end">
      <span>Updated: 2026-02-06 10:56 PT</span>

      <span class="mx-2">|</span> <a class="release-notes" href="#" (click)="$event.preventDefault(); openReleaseNotes()">Release Notes</a>
    </div>
  </div>
</footer>